import { cn } from "@/lib/utils";

/**
 * The frosted service card, matching the Figma component 1:1.
 *
 * Presentational only — it renders the card face and nothing else. The ambient
 * white glow behind it and any click/hover behaviour belong to whatever lays
 * the card out, since in the design those are part of the surrounding frame
 * rather than the card itself.
 *
 * `title` honours newlines (the design breaks titles onto two lines regardless
 * of available width).
 */
export function ServiceCard({
  title,
  description,
  image,
  className,
}: {
  title: string;
  description: string;
  image: string;
  className?: string;
}) {
  return (
    <div
      // Every design value below is pinned at lg: and given a smaller mobile
      // default, so lg and up renders exactly as before.
      className={cn(
        "flex w-full flex-col items-center justify-center gap-6 rounded-[28px] bg-white/70 px-5 py-7 outline outline-2 -outline-offset-2 outline-white/30 backdrop-blur-xl lg:gap-[30px] lg:rounded-[34px] lg:px-[25px] lg:py-[33px]",
        className,
      )}
    >
      <div className="flex flex-col items-center gap-2 self-stretch">
        <span className="whitespace-pre-line text-center font-suisse-intl-bold text-2xl capitalize leading-tight text-black sm:text-[28px] lg:text-[32px]">
          {title}
        </span>
        <span className="self-stretch text-center font-suisse-intl-medium text-base leading-relaxed text-[#595D71] lg:text-lg lg:leading-[28.8px]">
          {description}
        </span>
      </div>
      <img
        className="h-[132px] w-[151px] lg:h-[159px] lg:w-[182px]"
        src={image}
        alt=""
      />
    </div>
  );
}
